import { Component } from '@angular/core';

@Component({
  selector: 'accepted-invitation',
  templateUrl: './accepted-invitation.component.html',
  styleUrls: ['./accepted-invitation.component.scss'],
})
export class AcceptedInvitationComponent {
}
